import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { CrudApi } from '../../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { TipoHoraDto, TipoHoraInput, TipoHoraListItem } from './types';

const BASE = '/v1/hour-types';

export const tiposHoraApi: CrudApi<TipoHoraListItem, TipoHoraDto, TipoHoraInput> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<TipoHoraListItem>> {
    const { data } = await api.get<{
      data: TipoHoraListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, { params: toGenexusParams(query) });
    return normalizeListEnvelope(data);
  },
  async get(id) {
    const { data } = await api.get<{ data: TipoHoraDto }>(`${BASE}/${id}`);
    return data.data;
  },
  async create(input) {
    const { data } = await api.post<{ data: TipoHoraDto }>(BASE, input);
    return data.data;
  },
  async update(id, input) {
    const { data } = await api.put<{ data: TipoHoraDto }>(`${BASE}/${id}`, input);
    return data.data;
  },
  async remove(id) {
    await api.delete(`${BASE}/${id}`);
  },
};
